import * as types from 'store/modules/requestall/mutation-types'
import requestall from 'api/requestall'
import swal from 'sweetalert'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: {
      en: {
        HRES6NUC1: {},
        HRES6NUC2: {},
        HRES6NUC3: {}
      },
      th: {
        HRES6NUC1: {},
        HRES6NUC2: {},
        HRES6NUC3: {}
      }
    },
    columns: {
      en: {
        index: [{
          key: '',
          name: ''
        }]
      },
      th: {
        index: [{
          key: '',
          name: ''
        }]
      }
    },
    index: {
      total: 0,
      rows: []
    },
    indexSelected: [],
    dropdowns: {
      p_staappr: {
        en: {},
        th: {}
      },
      p_codapp: {
        en: {},
        th: {}
      }
    }
  },
  getters: {
    [types.GET_REQUESTALL_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_REQUESTALL_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_REQUESTALL_LABELS] (state) {
      return state.labels
    },
    [types.GET_REQUESTALL_INDEX] (state) {
      return state.index
    },
    [types.GET_REQUESTALL_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_REQUESTALL_DROPDOWNS] (state) {
      return state.dropdowns
    }
  },
  mutations: {
    [types.SET_REQUESTALL_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_REQUESTALL_COLUMNS] (state, columns) {
      state.columns.en = columns.en
      state.columns.th = columns.th
    },
    [types.SET_REQUESTALL_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_REQUESTALL_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_REQUESTALL_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_REQUESTALL_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    }
  },
  actions: {
    [types.TOGGLE_REQUESTALL_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_REQUESTALL_INDEX_DISP, indexDisp)
      commit(types.SET_REQUESTALL_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_REQUESTALL_COLUMNS_LABELS] ({ commit }) {
      requestall.getColumnsLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_REQUESTALL_COLUMNS, data.columns)
          commit(types.SET_REQUESTALL_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_REQUESTALL_INDEX] ({ commit }, searchParams) {
      requestall.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_REQUESTALL_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_REQUESTALL_DROPDOWNS] ({ commit }) {
      requestall.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_REQUESTALL_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/requestall/index.js